import { NavLink } from "react-router-dom";
import { styled } from '@mui/material/styles';

const CustomizedButtonLink = styled(NavLink)`
    color: inherit;
    text-decoration: inherit;
`;

export default CustomizedButtonLink;